import { PMPayment } from '../types/pm';
import { createProjectItemStore } from './createProjectItemStore';

export const usePaymentStore = createProjectItemStore<PMPayment>('payments');
